import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeone-key-features',
  templateUrl: './homeone-key-features.component.html',
  styleUrls: ['./homeone-key-features.component.scss']
})
export class HomeoneKeyFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
